import { render, staticRenderFns } from "./CustomersReportDashboard.vue?vue&type=template&id=af37e204&scoped=true&"
import script from "./CustomersReportDashboard.vue?vue&type=script&lang=js&"
export * from "./CustomersReportDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CustomersReportDashboard.vue?vue&type=style&index=0&id=af37e204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af37e204",
  null
  
)

export default component.exports